<div>
    <app-tool-bar [title]="'Department Configuration'" [iconName]="'pi-building'" [isAdd]="true"
        (handleAdd)="handleAddDepartment()"></app-tool-bar>
</div>

<div class="p-4 overflow-auto h-[85vh]">
    <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="loadData($event)" [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined"
        [loading]="loading">

        <!-- Header -->
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 5rem">S.No</th>
                <th *ngFor="let col of columns">
                    {{ col.header }}
                </th>
            </tr>
        </ng-template>

        <!-- Body -->
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
                <td>
                    <div style="margin-left: 5px;">
                        {{ rowIndex + 1 }}
                    </div>
                </td>
                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.type">
                        <ng-container *ngSwitchCase="'actions'">
                            <div *ngIf="!loading" (click)="setDepartmentData(rowData)">
                                <p-menu [tabindex]="undefined" #menu [model]="departmentActionItems" [popup]="true"
                                    appendTo="body">
                                </p-menu>
                                <button pButton type="button" (click)="menu.toggle($event)" icon="pi pi-ellipsis-v"
                                    class="p-button-rounded p-button-text"></button>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'user'">
                            {{ getFullName(rowData?.user)  || 'N/A' }}
                        </ng-container>

                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] || 'N/A' }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>

        <!-- Loading -->
        <ng-template pTemplate="loading">
            <tr>
                <td colspan="3" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <!-- Empty message -->
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columns.length + 1" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>

<!-- Add Department Dialog -->
<p-dialog [modal]="true" *ngIf="isAddDepartment" [(visible)]="isAddDepartment"
    [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }" closable="false" [style]="{ width: '60vw' }"
    [draggable]="false" [resizable]="false">
    <app-create-department [type]="'Create'" [allUsers]="allUsers" (closeDialog)="isAddDepartment = false"
        (reload)="reloadData()"></app-create-department>
</p-dialog>

<!-- Edit Department Dialog -->
<p-dialog [modal]="true" *ngIf="isEditDepartment" [(visible)]="isEditDepartment"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" closable="false" [style]="{ width: '50vw' }"
    [draggable]="false" [resizable]="false">
    <app-create-department [type]="'Update'" [departmentData]="departmentData" [allUsers]="allUsers"
        (closeDialog)="isEditDepartment = false" (reload)="reloadData()"></app-create-department>
</p-dialog>

<!-- Delete Department Dialog -->
<p-dialog [modal]="true" *ngIf="isDeleteDepartment" [(visible)]="isDeleteDepartment"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" closable="false" [style]="{ width: '30vw' }"
    [draggable]="false" [resizable]="false">
    <app-delete-department [departmentData]="departmentData" (closeDialog)="isDeleteDepartment = false"
        (reload)="reloadData()"></app-delete-department>
</p-dialog>